import { createSlice } from "@reduxjs/toolkit";

const initialState = {

  previewMode: "list",
  campaignPreview: false
};

const campaignSlice = createSlice({
  name: "campaign",
  initialState,
  reducers: {
    setPreviewMode(state, action) {
      state.previewMode = action.payload;
    },
    setCampaignPreview(state, action) {
      state.campaignPreview = action.payload;
    },
  },
});

export const { setPreviewMode, setCampaignPreview } = campaignSlice.actions;

export default campaignSlice.reducer;
